/* src/app/report/report.component.scss */
.section-container {
  width: 95%;
  margin: 0 auto 0 auto;
}
.section-container:last-of-type {
  margin-top: 40px;
}
.table-container {
  background-color: #3E3F48 !important;
  border-radius: 20px;
  width: 100%;
  padding: 0 40px 10px 40px;
}
.table-container .mat-mdc-cell {
  color: white;
}
.table-container .mat-mdc-cell a {
  text-decoration: none;
}
.table-container .mat-mdc-cell a span {
  text-decoration: none;
}
.table-container .mat-mdc-header-cell {
  color: white;
}
.filter-container {
  display: flex;
  justify-content: flex-start;
  height: 58px;
  align-items: center;
}
.activity-title {
  margin: 0;
}
.filter-input {
  width: 300px;
  height: 33px;
  border-radius: 20px;
  margin-left: 20px;
  padding: 0 15px 0 15px;
  border: 0;
  background-image: url("./media/search.svg");
  background-repeat: no-repeat;
  background-position: 95% 50%;
}
.footer-cell {
  flex: 1;
  flex-grow: 1;
  text-align: left;
  border-bottom: none;
}
.footer-row {
  display: flex;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  min-height: 48px;
}
.mat-mdc-cell {
  text-align: left;
}
.mat-mdc-row {
  border-bottom: none;
}
a:hover {
  cursor: pointer;
}
.mat-column-client_name {
  min-width: 200px;
}
.mat-column-description {
  min-width: 250px;
}
.mat-column-email {
  min-width: 300px;
}
.mat-column-code {
  max-width: 150px;
}
.summary {
  display: flex;
  text-align: left;
  justify-content: center;
  gap: 20px;
  margin: 20px;
}
.summary .spacer {
  flex: 1;
}
.summary .info {
  text-align: center;
}
.summary .info.clickable.green img {
  filter: brightness(0) saturate(100%) invert(92%) sepia(2%) saturate(6308%) hue-rotate(102deg) brightness(92%) contrast(88%);
}
.summary .info.clickable:hover {
  cursor: pointer;
}
.summary .info .stat2 {
  color: #80dec4;
  margin-top: 40px;
  margin-bottom: 10px;
  font-size: 3rem;
  line-height: 1.19;
}
.summary .info .stat2 img {
  width: 60px;
}
.summary .info .stat {
  color: #80dec4;
  margin-top: 40px;
  margin-bottom: 20px;
  font-size: 3rem;
  line-height: 1.19;
}
.summary .info .stat img {
  width: 40px;
}
h1 {
  text-align: left;
  font-size: 2.5rem;
  padding-left: 20px;
}
h2 {
  text-align: right;
  padding-right: 20px;
  margin-top: -20px;
}
h2.client-name-super {
  position: fixed;
  top: 70px;
  right: 0;
  margin-top: 0;
}
.mat-column-complete.completed-yes {
  color: #3cb93c;
}
.type-selector {
  padding: 6px;
  border-radius: 20px;
  margin-left: 10px;
}
.stat-skeleton {
  height: 3rem;
  width: 60px;
  border-radius: 4px;
  margin: 40px auto 20px auto;
  display: block;
}
.special-padding {
  padding: 0px 60px 0px 0px;
}
.special-padding .mat-cell {
  text-align: center;
}
/*# sourceMappingURL=report.component.css.map */
